import {
  finalFormParsers,
  isNumber,
  required,
  requiredWithMessage,
} from "common/validate";
import {
  QUESTION_KEYS,
  QUESTION_OPTION_KEYS,
} from "schedule-v2/components/recorded-content/recordedContent.data";
import { composeValidators } from "utils/validations";

export const validators = {
  [QUESTION_KEYS.options]: composeValidators(required, (options) => {
    const optionsAdded = options?.filter((option) => option);
    const isAllOptionsAdded = optionsAdded?.length === options?.length;
    if (isAllOptionsAdded) {
      const hashSet = new Set(
        optionsAdded?.map(
          (option) => option && option[QUESTION_OPTION_KEYS.option]
        ) || []
      );
      const isAlreadyAdded = hashSet.size !== optionsAdded?.length;
      return isAlreadyAdded && "Please enter unique options.";
    }
  }),
  [QUESTION_KEYS.totalMarks]: requiredWithMessage(
    "Please enter the total marks to be alloted to this question."
  ),
};

export const formatters = {
  [QUESTION_KEYS.totalMarks]: (value) =>
    isNumber(value) ? finalFormParsers.number(value) : "",
};

export const parsers = {
  [QUESTION_KEYS.totalMarks]: (value) => {
    const parseNumber =
      value !== undefined ? value.replace(/[^0-9.]/g, "") : "";
    return isNumber(parseNumber) ? finalFormParsers.number(parseNumber) : "";
  },
};
